import { __assign, __decorate, __extends, __metadata } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { FormContext } from '../FormContext';
import { BindPropsHelper, CheckboxType } from '../PropTypes';
import { Validation, Utils } from '@singularsystems/neo-core';
import ComponentBase from '../ComponentBase';
var FloatingFormGroup = /** @class */ (function (_super) {
    __extends(FloatingFormGroup, _super);
    function FloatingFormGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.isFocused = false;
        _this.containerRef = React.createRef();
        _this.editorRef = React.createRef();
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.labelClick = _this.labelClick.bind(_this);
        return _this;
    }
    FloatingFormGroup.prototype.onFocus = function (e) {
        if (this.containerRef.current) {
            this.containerRef.current.classList.add("focused");
        }
        if (this.originalOnFocus) {
            this.originalOnFocus(e);
        }
        if (this.placeholder && this.editorRef.current) {
            this.editorRef.current.placeholder = this.placeholder;
        }
        this.isFocused = true;
    };
    FloatingFormGroup.prototype.onBlur = function (e) {
        if (this.containerRef.current) {
            this.containerRef.current.classList.remove("focused");
        }
        if (this.originalOnBlur) {
            this.originalOnBlur(e);
        }
        if (this.editorRef.current) {
            this.editorRef.current.placeholder = "";
        }
        this.isFocused = false;
    };
    FloatingFormGroup.prototype.labelClick = function (e) {
        e.preventDefault();
        if (this.editorRef.current) {
            this.editorRef.current.focus();
        }
    };
    FloatingFormGroup.prototype.render = function () {
        var allProps = BindPropsHelper.normaliseContainerProps(this, this.props, true, false);
        var containerProps = allProps.container;
        var labelText = containerProps.label ? containerProps.label : allProps.bind.propertyInfo.readableName;
        var displayInfo = allProps.bind.validator.getDisplayState(this.context.validationDisplayMode);
        var showValidation = displayInfo.severity != Validation.RuleSeverity.None;
        if (!allProps.editorDom) {
            allProps.editorDom = {};
        }
        ;
        this.originalOnFocus = allProps.editorDom.onFocus;
        this.originalOnBlur = allProps.editorDom.onBlur;
        allProps.editorDom.onFocus = this.onFocus;
        allProps.editorDom.onBlur = this.onBlur;
        allProps.editor.inputElement = this.editorRef;
        this.placeholder = BindPropsHelper.getPlaceholderText(allProps.editor.placeholder, allProps.bind.propertyInfo);
        allProps.editor.placeholder = "";
        if (BindPropsHelper.getCheckBoxType(allProps) !== CheckboxType.None) {
            throw Error("FormGroupFloating does not support checkboxes, use FormGroup.");
        }
        var editor = BindPropsHelper.getFormControl(allProps);
        allProps.containerDom.className = Utils.joinWithSpaces(allProps.containerDom.className, "neo-form-group-floating");
        if (allProps.bind.value) {
            allProps.containerDom.className += " has-value";
        }
        if (showValidation) {
            allProps.containerDom.className += " " + displayInfo.additionalClassName;
        }
        if (this.isFocused) {
            allProps.containerDom.className += " focused";
        }
        return (React.createElement("div", __assign({}, allProps.containerDom, { ref: this.containerRef }),
            React.createElement("div", null,
                React.createElement("label", { htmlFor: allProps.uniqueID, className: "neo-floating-label", onMouseDown: this.labelClick }, labelText),
                editor),
            showValidation &&
                React.createElement("div", { className: "invalid-feedback " + displayInfo.additionalClassName, style: { display: "block" } },
                    displayInfo.severity == Validation.RuleSeverity.AsyncBusy && React.createElement("span", { className: "spinner-grow" }),
                    React.createElement("span", null, displayInfo.displayText))));
    };
    FloatingFormGroup.contextType = FormContext;
    FloatingFormGroup = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FloatingFormGroup);
    return FloatingFormGroup;
}(ComponentBase));
export default FloatingFormGroup;
